import SectionHeader from "@/components/SectionHeader";
import Reveal from "@/components/Reveal";
import { PROCESS_STEPS } from "@/lib/content";

const ProcessSection = ({
  eyebrow = "Why Kryvo",
  title = "From Idea to Digital Product",
  description = "A clear, collaborative process that takes your product from first conversation to launch — and beyond.",
  steps = PROCESS_STEPS,
  testId = "process-section",
}) => (
  <section className="container-x py-20 sm:py-28" data-testid={testId}>
    <SectionHeader eyebrow={eyebrow} title={title} description={description} />
    <ol
      className={`relative mx-auto mt-16 grid max-w-5xl gap-10 md:gap-6 ${
        steps.length > 4 ? "md:grid-cols-5 md:max-w-6xl" : "md:grid-cols-4"
      }`}
    >
      <span
        className="absolute left-6 top-0 h-full w-px bg-kryvo-green/15 md:left-0 md:top-6 md:h-px md:w-full"
        aria-hidden="true"
      />
      {steps.map((s, i) => (
        <Reveal as="li" key={s.step} delay={i * 0.1} className="relative flex gap-5 md:flex-col md:gap-0">
          <span className="relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-kryvo-green/20 bg-white font-display text-sm font-semibold text-kryvo-green shadow-[0_8px_24px_-10px_rgba(6,78,42,0.35)]">
            {s.step}
          </span>
          <div className="md:mt-6">
            <h3 className="text-lg font-semibold text-kryvo-ink">{s.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-kryvo-ink/60">{s.desc}</p>
          </div>
        </Reveal>
      ))}
    </ol>
  </section>
);

export default ProcessSection;
